import "./atoms-v2886.js";
import { memo as t } from "./atoms-v21087.js";
const e = /* @__PURE__ */ t(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
export {
  e as supportsWaapi
};
